import { apiClient } from './api.client';
import type {
  AlertBanner,
  CreateAlertBannerDto,
  UpdateAlertBannerDto,
  AlertBannersResponse,
  AlertBannerResponse,
} from '@lnr-v2/types';

export class AlertBannerService {
  async getAll(page = 1, limit = 20): Promise<AlertBannersResponse> {
    return apiClient
      .get(`alert-banners?page=${page}&limit=${limit}`)
      .json<AlertBannersResponse>();
  }

  async getById(id: string): Promise<AlertBanner> {
    const response = await apiClient
      .get(`alert-banners/${id}`)
      .json<AlertBannerResponse>();
    return response.data!;
  }

  async create(data: CreateAlertBannerDto): Promise<AlertBanner> {
    const response = await apiClient
      .post('alert-banners', { json: data })
      .json<AlertBannerResponse>();
    return response.data!;
  }

  async update(id: string, data: UpdateAlertBannerDto): Promise<AlertBanner> {
    const response = await apiClient
      .put(`alert-banners/${id}`, { json: data })
      .json<AlertBannerResponse>();
    return response.data!;
  }

  async delete(id: string): Promise<void> {
    await apiClient.delete(`alert-banners/${id}`);
  }

  async activate(id: string): Promise<AlertBanner> {
    const response = await apiClient
      .put(`alert-banners/${id}/activate`)
      .json<AlertBannerResponse>();
    return response.data!;
  }

  async deactivate(id: string): Promise<AlertBanner> {
    const response = await apiClient
      .put(`alert-banners/${id}/deactivate`)
      .json<AlertBannerResponse>();
    return response.data!;
  }
}

export const alertBannerService = new AlertBannerService();
